<section class="admin-page" id="container">
  <app-menu></app-menu>
  <section id="main-content">
    <section class="wrapper">
      <div class="header">
        <h3 class="title">Admin Billing</h3>
      </div>
      <div *ngIf="error.active">
        <div class="alert alert-danger">{{ error.message }}</div>
        <pre style="display: none">{{ error.stack }}</pre>
      </div>
      <div *ngIf="!error.active" class="content">
        This page is not implemented
      </div>

<div class="paypal-button-container"></div>
<div class="paypal-button-container2"></div>

    </section>
  </section>
</section>

